import React from 'react';
import { Header, Title } from '../ShelfPage/styles';
import RetailersView from '../views/RetailersView';
import { GenericNavigationTabs } from 'src/components/BeaconV2Components/SubtabNav/SubtabNavigation';
// import DataExplorerView from '../DataExplorerView/DataExplorerView';

export interface DataTabProps {
  search: string;
  selectedCountries: string[];
  selectedIndustries: string[];
  onSearchChange: (v: string) => void;
  onToggleCountry: (id: string) => void;
  onToggleIndustry: (id: string) => void;
  onOptionsChange: (opts: { countries: { id: string; label: string }[]; industries: { id: string; label: string }[] }) => void;
}

const DataTab: React.FC<DataTabProps> = ({
  search,
  selectedCountries,
  selectedIndustries,
  onSearchChange,
  onToggleCountry,
  onToggleIndustry,
  onOptionsChange
}) => {
  const [tab, setTab] = React.useState<'retailers'>('retailers');
  return (
    <div style={{ width: 1045 }}>
      <Header>
        <Title>Coverage</Title>
      </Header>
      <div>
        <GenericNavigationTabs
          tab={tab}
          tabs={[
            {
              label: 'Retailers',
              onClick: () => setTab('retailers'),
              value: 'retailers'
            }
          ]}
        />
        {tab === 'retailers' ? (
          <RetailersView
            search={search}
            selectedCountries={selectedCountries}
            selectedIndustries={selectedIndustries}
            onOptionsChange={onOptionsChange}
            showInlineFilters={false}
            onSearchChange={onSearchChange}
            onToggleCountry={onToggleCountry}
            onToggleIndustry={onToggleIndustry}
          />
        ) : null}
      </div>
    </div>
  );
};

export default DataTab;
